export enum UserPermissions {
  //Member Permissions
  MemberViewList = "MEMBER_ADMIN_VIEW_LIST",
  MemberAddMember = "MEMBER_ADMIN_ADD_MEMBER",
  MemberPreview = "MEMBER_ADMIN_PREVIEW_MEMBER",
  MemberViewPersonal = "MEMBER_ADMIN_VIEW_PERSONAL",
  MemberManagePersonal = "MEMBER_ADMIN_MANAGE_PERSONAL",
  MemberViewEmployment = "MEMBER_ADMIN_VIEW_EMPLOYMENT",
  MemberDownloadDocuments = "MEMBER_ADMIN_DOWNLOAD_MEMBER_DOCUMENTS",
  MemberManageEmployment = "MEMBER_ADMIN_MANAGE_EMPLOYMENT",
  MemberViewTeamRoles = "MEMBER_ADMIN_VIEW_TEAMS_ROLES",
  MemberManageTeamRoles = "MEMBER_ADMIN_MANAGE_TEAMS_ROLES",
  MemberViewCheckins = "MEMBER_ADMIN_VIEW_CHECKINS",
  MemberManageCheckins = "MEMBER_ADMIN_MANAGE_CHECKINS",
  MemberViewStrengthFinder = "MEMBER_ADMIN_VIEW_STRENGTHSFINDER",
  MemberManageStrengthFinder = "MEMBER_ADMIN_MANAGE_STRENGTHSFINDER",
  //Team Permissions
  TeamViewList = "TEAMS_ADMIN_VIEW_LIST",
  TeamAddTeam = "TEAMS_ADMIN_ADD_TEAM",
  TeamViewDetails = "TEAMS_ADMIN_VIEW_TEAM_DETAILS",
  TeamManageDetails = "TEAMS_ADMIN_MANAGE_TEAM_DETAILS",
  TeamAddMembers = "TEAMS_ADMIN_ADD_MEMBER_TO_TEAM",
  //Role Permissions
  RoleViewList = "ROLES_ADMIN_VIEW_ROLE_LIST",
  RoleAddRole = "ROLES_ADMIN_ADD_ROLE",
  RoleViewDetails = "ROLES_ADMIN_VIEW_ROLE_DETAILS",
  RoleManageDetails = "ROLES_ADMIN_MANAGE_ROLE_DETAILS",
  RoleManageMembers = "ROLES_ADMIN_MANAGE_ROLE_MEMBERS",
  RoleManagePermissions = "ROLES_ADMIN_MANAGE_ROLE_PERMISSIONS",
  //Office Permissions
  OfficeViewList = "OFFICES_ADMIN_VIEW_OFFICES_LIST",
  OfficeAddOffice = "OFFICES_ADMIN_ADD_OFFICE",
  OfficeViewDetails = "OFFICES_ADMIN_VIEW_OFFICE_DETAILS",
  OfficeManageDetails = "OFFICES_ADMIN_MANAGE_OFFICE_DETAILS",
  OfficeViewRooms = "OFFICES_ADMIN_VIEW_OFFICE_ROOMS",
  OfficeManageRooms = "OFFICES_ADMIN_MANAGE_OFFICE_ROOMS",
  OfficeManageMembers = "OFFICES_ADMIN_MANAGE_OFFICE_MEMBERS",
  //Company Permissions
  CompanyViewList = "COMPANIES_ADMIN_VIEW_COMPANIES_LIST",
  CompanyViewDetails = "COMPANIES_ADMIN_VIEW_COMPANY_DETAILS",
  CompanyManageDetails = "COMPANIES_ADMIN_MANAGE_COMPANY_DETAILS",
  CompanyManageOffices = "COMPANIES_ADMIN_MANAGE_COMPANY_OFFICES",
  //Dashboard Permissions
  DashboardView = "DASHBOARD_VIEW_EXECUTIVE",
  DashboardViewLead = "DASHBOARD_VIEW_TEAM_LEADER",
  DashboardViewMemberDetails = "DASHBOARD_VIEW_MEMBER_DETAILS",
}
